import React from 'react'
import Container from 'src/Home/AdditionalDetail/MobileView/Container'
import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'

interface Props {
  props: RouteComponentProps
}

const OuterContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center-horizontal;
  margin-left: 32px;
  margin-right: 32px;
  margin-top: 16px;
`

export const FullScreenContainer = ({ props }: Props) => {
  const state: any = props.location.state
  const server_host: string = state?.serverHost
  const user_location: string = state?.user_location
  const client_ip: string = state?.ipAddress
  const provider_name: string = state?.provider
  const server_location: string = state?.serverLocation
  const network_type: string = state?.network_type
  return (
    <OuterContainer>
      <Container
        server_host={server_host}
        location={user_location}
        client_ip={client_ip}
        provider_name={provider_name}
        server_location={server_location}
        network_type={network_type}
      />
    </OuterContainer>
  )
}
